const lang = (state = 'en', action) => {
	switch (action.type) {
		case 'CHANGE_LANG':
			return action.lang;
		default:
			return state;
	}
};
export default lang;
